import React, { useEffect, useState } from 'react';
import { captcahRequest, captcahRequestValidate } from '../actions/User';
import { useDispatch } from 'react-redux';
import { Input } from 'reactstrap';
import "./captchaForm.css";

const CaptchaForm = ({ onCaptchaChange }) => {
  const [captcha, setCaptcha] = useState({ captchaId: '', problem: '', csrfToken: '' });
  const [answer, setAnswer] = useState('');
  const dispatch = useDispatch();

  const loadCaptcha = async () => {
    try {
      const result = await dispatch(captcahRequest());
      setCaptcha(result.data);
      onCaptchaChange({ sessionId: result.sessionId, answer: '' });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    loadCaptcha();
  }, []);
  useEffect(() => {
    onCaptchaChange({ sessionId: captcha.sessionId, answer: answer, csrfToken: captcha.csrfToken });
  }, [answer, captcha.captchaId, captcha.csrfToken]);

  return (
    <div className="captchaBox">
      <div className="captchaInput">
        {captcha?.problem || '...'}
      </div>
      <span className="equalsSign">=</span>
      <Input
        type="text"
        value={answer}
        className="captchaInput"
        placeholder="Type the answer"
        autoComplete="off"
        onChange={(e) => setAnswer(e.target.value)}
      />
    </div>
  );
};
export default CaptchaForm;